import React, { useEffect, useState } from "react";
import { Grid, SingleBarChart, makeStyles, setLocale, BoxNumber } from "../../../../";
import _ from "lodash";
var useStyles = makeStyles(function (theme) {
  return {
    boxContainer: {
      display: "flex",
      padding: "20px 0",
      "align-items": "flex-end"
    },
    charts: {
      // display: "flex",
      "justify-content": "space-between",
      padding: "25px"
    },
    justifiySpaceBetween: {
      "justify-content": "space-between"
    },
    chartContainer: {
      margin: "20px",
      background: "#e8e8e81a",
      "align-items": "center",
      "justify-content": "space-between",
      "padding-top": "40px" // display: "flex",

    }
  };
});

var SubscriptionsData = function SubscriptionsData(_ref) {
  var dashboard = _ref.dashboard,
      country = _ref.country,
      forecast = _ref.forecast;
  var classes = useStyles(); // console.log("SubscriptionsData", dashboard, country);

  useEffect(function () {
    setLocale();
  }, []);
  return dashboard && dashboard[country] ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12,
    className: [classes.charts, classes.chartContainer].join(" ")
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(BoxNumber, {
    total: true,
    value: dashboard[country].total,
    title: "Total" // locale={country}

  })), dashboard && dashboard[country] && dashboard[country].sub_invoices && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(SingleBarChart, {
    height: 370 // data={dashboard[country] && dashboard[country].sub_invoices}
    ,
    data: _.concat(dashboard[country].sub_invoices, forecast),
    groupedBy: "date",
    acc: "subtotal" // brush
    ,
    label: true // locale={country}

  })))) : null;
};

export { SubscriptionsData };